/*
 * newsbot - Shared importance score badge
 */

import { classNames } from "@utils";

interface ImportanceBadgeProps {
  score: number | null;
  size?: "sm" | "md";
}

export const ImportanceBadge = ({ score, size = "sm" }: ImportanceBadgeProps) => {
  if (score == null) {
    return <span className="text-gray-400 dark:text-gray-500 text-xs">—</span>;
  }

  const displayScore = (score * 10).toFixed(1);
  const colorClass =
    score >= 0.7
      ? "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300"
      : score >= 0.4
        ? "bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-300"
        : "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300";

  const sizeClass = size === "md" ? "px-2.5 py-1 text-sm" : "px-2 py-0.5 text-xs";

  return (
    <span className={classNames("rounded-md font-medium", sizeClass, colorClass)}>
      {displayScore}
    </span>
  );
};
